/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { s as show } from '../../../index-48bf95da.js';
import '../../../index-892d8eee.js';

var mini = show;

export { mini as default };
